import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import TButton from './TButton';
import widgetService from '../widget-service';
import { WidgetContext } from '../WidgetContext';
import { RadioGroup, Radio } from './RadioGroup';
import AnimatedInput from './AnimatedInput';
import AnimatedTextarea from './AnimatedTextArea';
import icon from '../assets/send-icon.png';
import CustomCheckbox from './CheckboxComponent';
import AnimatedMaskedInput from './AnimatedMaskedInput';

const Icon = styled.img`
  width: 20px;
  height: 20px;
`;
export default styled(({ clearMessage, onDidDismiss, ...rest }) => {
  const { state, dispatch } = useContext(WidgetContext);
  const [firstName, setFirstName] = useState('');
  const [emailAddress, setEmailAddress] = useState('');
  const [message, setMessage] = useState('');
  const [classification, setClassification] = useState('Sales');
  const [phone, setPhone] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (checked: boolean) => {
    setIsChecked(checked);
  };

  const sendMessage = async () => {
    // Trigger a google analytics event if ga is a installed

    console.log('I AM SENDING MESSAGE: ');
    try {
      if (sending) {
        return;
      }

      if (!firstName.trim()) {
        return setError('Please enter in your full name.');
      }

      if (state.config.smswidgetconfig.show_email_field) {
        if (!emailAddress.trim()) {
          return setError('Please enter a valid email address.');
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(emailAddress)) {
          return setError('Please enter a valid email address.');
        }
      }

      if (!message) {
        return setError('Please enter the message.');
      }

      if (!phone) {
        return setError('Please enter in a valid phone number.');
      }

      setSending(true);
      const splitName = firstName.split(' ');
      const first_name = splitName[0] ?? 'Unknown';
      const last_name = splitName.slice(1).join(' ') || 'Unknown';
      const res = await widgetService.createMessage({
        // Add URL to the message
        message: `${message} \n\nFrom: ${window.location.href}`,
        first_name,
        last_name,
        email_address: emailAddress,
        client: state.clientId,
        classification,
        lead_type: 'Web',
        // strip all but the + sign and numbers
        phone_number: phone.replace(/[^+\d]/g, ''),
      });
      console.log('Response: ', res.data.id);

      // @ts-ignore
      if ('function' === typeof ga) {
        let arr: any = [];
        // @ts-ignore
        ga(function () {
          // Logs an array of all tracker objects.
          // @ts-ignore
          arr = ga.getAll();
        });
        console.log(arr);
        arr.forEach(function (e: any, i: any) {
          let trackerName = e.get('name');
          trackerName += '.send';
          let dataObj = {
            hitType: 'event',
            eventCategory: 'lead',
            eventAction: 'created',
            eventLabel: 'tecobi-widget-lead',
          };
          console.log(trackerName, dataObj);
          // @ts-ignore
          ga(trackerName, dataObj);
          if ('object' === typeof (window as any).dataLayer) {
            (window as any).dataLayer.push({ event: 'tecobi-widget-lead' });
          }
        });
      } else if ('function' === typeof (window as any).gtag) {
        (window as any).gtag('event', 'tecobi_widget_lead', {
          event_category: 'TECOBI Widget',
          event_label: 'Lead Submission',
        });
        (window as any).gtag('event', 'conversion', {
          value: 0,
          currency: 'USD',
          transaction_id: String(res.data.id),
        });
      }
      onDidDismiss?.();
      setFirstName('');
      setError('');
      setEmailAddress('');
      setPhone('');
      setMessage('');
      clearMessage?.();
      setClassification('Sales');
      dispatch({
        type: 'set',
        value: {
          toast: 'Your message has been sent. We will text you back shortly.',
        },
      });
    } catch (e) {
      console.error(e);
    } finally {
      setSending(false);
    }
  };

  return (
    <div {...rest} style={{ textAlign: 'center' }}>
      <p className='error'>{error}</p>
      <RadioGroup
        className='classification-group'
        name='classification'
        onClickRadioButton={setClassification}
        selectedValue={classification}
      >
        <Radio
          color={state.config.smswidgetconfig.background_color}
          value='Sales'
          labelText='Sales'
        />
        <Radio
          color={state.config.smswidgetconfig.background_color}
          value='Service'
          labelText='Service'
        />
      </RadioGroup>
      <AnimatedInput
        style={{ backgroundColor: 'white' }}
        label='Full Name *'
        defaultValue={firstName}
        value={firstName}
        // autoComplete={firstName}
        // name="given-name"
        onChange={(e: any) => setFirstName(e.target.value)}
      />
      {state.config.smswidgetconfig.show_email_field && (
        <AnimatedInput
          style={{ backgroundColor: 'white' }}
          label='Email Address *'
          type='email'
          defaultValue={emailAddress}
          value={emailAddress}
          onChange={(e: any) => setEmailAddress(e.target.value)}
        />
      )}
      <AnimatedMaskedInput
        style={{ backgroundColor: 'white' }}
        label='Mobile *'
        mask='+1 (999) 999-9999'
        value={phone}
        onChange={(e: any) => setPhone(e.target.value)}
      />
      <AnimatedTextarea
        // style={{height: '100px', textAlign: 'left'}}
        style={{ backgroundColor: 'white' }}
        label='Message *'
        value={message}
        onChange={(e: any) => setMessage(e.target.value)}
      />

      {/* <p className="disclaimer">
        By clicking send, I agree to receive text messages from{" "}
        {state.config.name} representatives and understand that no consent to
        texting is required for purchase of products or services. Message and
        data rates may apply. Reply Stop to Opt-Out.
      </p> */}
      <div>
        <CustomCheckbox
          color={state.config.smswidgetconfig.background_color}
          checked={isChecked}
          onChange={handleCheckboxChange}
          label={
            <>
              By checking this box, I agree to receive text messages from{' '}
              {state.config.name + ' '}
              at the phone number provided. Msg&Data rates may apply. I
              understand that I will receive communication messages 
              from {state.config.name}. Message frequency varies. I can
              opt-out at any time by texting STOP. For help, text HELP. For more
              information, please view the{' '}
              <a
                href={`https://tecobi-privacy-terms-extractor-4dzvfxebxa-uc.a.run.app/privacy?tecobiClientId=${state.clientId}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                <strong style={{ color: 'black' }}>Privacy Policy</strong>
              </a>{' '}
              and{' '}
              <a
                href={`https://tecobi-privacy-terms-extractor-4dzvfxebxa-uc.a.run.app/terms?tecobiClientId=${state.clientId}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                <strong style={{ color: 'black' }}>Terms of Service</strong>
              </a>
              .
            </>
          }
        />
      </div>
      {state.config.smswidgetconfig.show_powered_by && (
        <div style={{ justifyContent: 'flex-end', display: 'flex' }}>
          <p style={{ fontSize: 10, color: '#B2BEB5	' }}>
            Powered by{' '}
            <a
              style={{ color: '#B2BEB5	' }}
              href={`https://tecobi.com/?tecobiClientId=${state.clientId}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              TECOBI
            </a>
          </p>
        </div>
      )}

      <TButton
        style={{
          backgroundColor:
            isChecked && message && phone && firstName
              ? state.config.smswidgetconfig.background_color
              : '#D3D3D3',
          color: state.config.smswidgetconfig.text_color,
          filter: sending ? 'grayscale(100%)' : undefined,
          borderRadius: 50,
          width: '184px',
          height: '37px',
          justifyContent: 'center',
          fontSize: 14,
          flexDirection: 'row',
          display: 'inline-flex',
          alignItems: 'center',
          paddingLeft: 70,
          cursor:
            !isChecked || !message || !phone || !firstName
              ? 'default'
              : 'pointer',
        }}
        onClick={sendMessage}
        disabled={!isChecked || !message || !phone || !firstName}
      >
        <div>Send</div>
        <Icon
          src={icon}
          style={{ width: 10, height: 10, right: 10, marginLeft: 40 }}
        />
      </TButton>
    </div>
  );
})`
  // background-color: white;
  // border-radius: 6px;
  // box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  // box-sizing: border-box;
  padding: 10px 20px;
  // position: absolute;
  margin-top: 40px;
  // left: 10px;
  // right: 10px;
  // bottom: 10px;
  // z-index: 10;

  h4 {
    margin: 10px 0;
  }

  .classification-group {
    display: grid;
    grid-template-columns: 1fr 3fr;
    // margin-top: 10px;
  }

  .disclaimer {
    color: rgb(100, 100, 100);
    font-size: 12px;
  }

  .error {
    color: red;
    font-size: 12px;
    font-weight: bold;
  }

  .maskedclass {
    font-family: 'Fira Sans', sans-serif;
    font-size: 13px !important;
    color: #605f5f !important;
  }

  > input {
    width: 100%;
    margin-bottom: 5px;
  }
`;
